import { TurboModuleRegistry } from "react-native";
export default TurboModuleRegistry.get("RNHapticFeedback");
//# sourceMappingURL=NativeHapticFeedback.js.map